import React, { useState } from "react";
import apiClient from "../api/apiClient";

const ConsultarOCModal = ({ onClose }) => {
  const [docNum, setDocNum] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null); // { header, lines }

  const renderEstadoBadge = (estado, { large } = {}) => {
    const val = (estado || "").toString();
    const s = val.toLowerCase();
    const base = {
      display: "inline-block",
      padding: large ? "0.25rem 0.65rem" : "0.15rem 0.5rem",
      borderRadius: "999px",
      fontSize: large ? "1rem" : "0.75rem",
      fontWeight: large ? 700 : 600,
      lineHeight: 1.2,
      verticalAlign: "middle",
      border: "1px solid transparent",
    };
    if (s.includes("abier")) {
      return (
        <span
          style={{
            ...base,
            backgroundColor: "#d1e7dd", // soft green (bootstrap success subtle)
            color: "#0f5132", // dark green text
            borderColor: "#badbcc",
          }}
          title={val}
        >
          {val}
        </span>
      );
    }
    if (s.includes("cerr")) {
      return (
        <span
          style={{
            ...base,
            backgroundColor: "#f8d7da", // soft red (bootstrap danger subtle)
            color: "#842029", // dark red text
            borderColor: "#f5c2c7",
          }}
          title={val}
        >
          {val}
        </span>
      );
    }
    return (
      <span
        style={{
          ...base,
          backgroundColor: "#e2e3e5", // soft gray
          color: "#41464b",
          borderColor: "#d3d6d8",
        }}
        title={val}
      >
        {val || "—"}
      </span>
    );
  };

  const fetchOC = async () => {
    setError("");
    setData(null);
    const n = (docNum || "").trim();
    if (!n) {
      setError("Ingrese el número de Orden de Compra.");
      return;
    }
    setLoading(true);
    try {
      const resp = await apiClient.get("/purchase-orders", {
        params: { DocNum: n },
      });
      setData(resp.data);
    } catch (e) {
      setError(e?.response?.data?.error || e?.response?.data?.message || "No se encontró la OC o ocurrió un error.");
    } finally {
      setLoading(false);
    }
  };

  const fmtDate = (s) => {
    if (!s) return "";
    const d = new Date(s);
    if (isNaN(d)) return s;
    return d.toLocaleDateString("es-PY");
  };

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-dialog-scrollable modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title">Consultar Orden de Compra</h6>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <div className="input-group">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Número de OC"
                  value={docNum}
                  onChange={(e) => setDocNum(e.target.value)}
                />
                <button className="btn btn-primary" type="button" onClick={fetchOC} disabled={loading}>
                  {loading ? "Buscando..." : "Obtener OC"}
                </button>
              </div>
            </div>
            {error && <div className="alert alert-danger py-1 small">{error}</div>}

            {data && (
              <>
                <div className="mb-2 small">
                  <div className="d-flex align-items-center justify-content-between" style={{ gap: ".5rem" }}>
                    <div><strong>Proveedor:</strong> {data.header?.Proveedor}</div>
                    {data?.header?.Estado && (
                      <div className="d-flex align-items-center" style={{ gap: ".5rem" }}>
                        <span className="text-muted" style={{ fontSize: ".85rem" }}>Estado:</span>
                        {renderEstadoBadge(data.header.Estado, { large: true })}
                      </div>
                    )}
                  </div>
                  <div><strong>Fecha OC:</strong> {fmtDate(data.header?.FechaOC)}</div>
                  <div><strong>Fecha de Entrega:</strong> {fmtDate(data.header?.FechaEntrega)}</div>
                </div>
                <div className="table-responsive">
                  <table className="table table-sm table-bordered">
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Descripción</th>
                        <th>Cant. Pedida</th>
                        <th>Cant. Pendiente</th>
                        <th>Almacén</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.lines?.map((ln) => {
                        const pending = Number(ln.OpenQuantity ?? 0);
                        const isComplete = pending <= 0;
                        const cellStyle = isComplete
                          ? { backgroundColor: "#f1f3f5", color: "#6c757d" }
                          : undefined;
                        return (
                          <tr
                            key={ln.LineNum}
                            title={isComplete ? "Línea completada" : undefined}
                          >
                            <td style={cellStyle}>{ln.ItemCode}</td>
                            <td style={cellStyle}>{ln.Description}</td>
                            <td style={{ textAlign: "right", ...cellStyle }}>
                              {Number(ln.Quantity ?? 0).toLocaleString("es-ES")}
                            </td>
                            <td style={{ textAlign: "right", ...cellStyle }}>
                              {Number(ln.OpenQuantity ?? 0).toLocaleString("es-ES")}
                            </td>
                            <td style={cellStyle}>{ln.WarehouseCode}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultarOCModal;
